export default "__VITE_ASSET__DHQlvEa4__"